var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutubeImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Youtube Social Icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 22",
    width: 50,
    height: 50,
    rx: 5,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.0002 14.4739C26.1252 14.4739 27.2791 14.5028 28.3975 14.5502L29.7186 14.6134L30.9831 14.6884L32.1673 14.7686L33.2489 14.8528C34.4226 14.9427 35.5271 15.4435 36.368 16.2673C37.2089 17.0912 37.7323 18.1851 37.8462 19.3568L37.8989 19.916L37.9975 21.1133C38.0897 22.3541 38.1581 23.7068 38.1581 25.0002C38.1581 26.2936 38.0897 27.6462 37.9975 28.887L37.8989 30.0844C37.8818 30.2765 37.8647 30.462 37.8462 30.6436C37.7323 31.8155 37.2086 32.9096 36.3675 33.7334C35.5263 34.5573 34.4215 35.058 33.2475 35.1476L32.1686 35.2305L30.9844 35.312L29.7186 35.387L28.3975 35.4502C27.2657 35.4994 26.133 35.5248 25.0002 35.5265C23.8673 35.5248 22.7346 35.4994 21.6028 35.4502L20.2818 35.387L19.0173 35.312L17.8331 35.2305L16.7515 35.1476C15.5777 35.0577 14.4733 34.5568 13.6324 33.733C12.7915 32.9092 12.268 31.8153 12.1541 30.6436L12.1015 30.0844L12.0028 28.887C11.9022 27.5938 11.8487 26.2973 11.8423 25.0002C11.8423 23.7068 11.9107 22.3541 12.0028 21.1133L12.1015 19.916C12.1186 19.7239 12.1357 19.5384 12.1541 19.3568C12.268 18.1853 12.7913 17.0915 13.6319 16.2677C14.4725 15.444 15.5767 14.943 16.7502 14.8528L17.8304 14.7686L19.0147 14.6884L20.2804 14.6134L21.6015 14.5502C22.7337 14.501 23.8669 14.4756 25.0002 14.4739ZM22.3686 21.8094V28.191C22.3686 28.7989 23.0265 29.1778 23.5528 28.8752L29.0791 25.6844C29.1994 25.6152 29.2993 25.5155 29.3687 25.3954C29.4382 25.2752 29.4747 25.1389 29.4747 25.0002C29.4747 24.8614 29.4382 24.7251 29.3687 24.605C29.2993 24.4849 29.1994 24.3852 29.0791 24.316L23.5528 21.1265C23.4328 21.0572 23.2966 21.0207 23.1579 21.0207C23.0193 21.0208 22.8831 21.0573 22.7631 21.1266C22.6431 21.196 22.5434 21.2957 22.4742 21.4158C22.4049 21.5359 22.3685 21.6721 22.3686 21.8107V21.8094Z",
    fill: "#1C1E2E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeImg);
export default __webpack_public_path__ + "static/media/YoutubeImg.9f23ea43f8b7887d9db46715be7b338b.svg";
export { ForwardRef as ReactComponent };